module.exports = __webpack_public_path__ + "img/hand-denied.f0585530.png";